import { makeStyles } from "@material-ui/core"

export const loadCardStyle = makeStyles((theme) => ({
    loadBox: {
        padding: '0.5em',
        width: '100%',
        height: '100%',
    },
    cardItem: {
        display: 'flex',
        width: '22%'
    },
    btns: {
        display: 'flex',
        alignItems: 'flex-end',
        marginLeft: 'auto',
    },
    lastCol: {

    },
    statusCardItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '0.5em',
        marginLeft: '-2.5em'
    },
    displayAddressWrapper: {
        fontWeight: 'bold',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center' 
    },
    locationWrapper: {
        marginLeft: '1em'
    },
    locationDateWrapper: {
        //marginBottom: '10%'
        marginTop: '1px'
    },
    confirmedDateTextWrapper: {
        fontWeight: 'bold',
        fontSize: '14px',
        marginTop: '8px',

    },
    upwardArrow: {
        background: '#FF5A4F',
        padding: '1px',
        borderRadius: '50%',
        transform: 'rotate(90deg)',
        '& path': {
            fill: 'white'
        }
    },
    downwardArrow: {
        background: '#32C997',
        padding: '1px',
        borderRadius: '50%',
        transform: 'rotate(90deg)',
        '& path': {
            fill: 'white'
        }
    },
    status: {
        fontSize: '1rem',
        fontWeight: 400
    },
    statusDate: {
        opacity: 0.6
    },
    vin: {
        //fontWeight: 'bold',
        '& a': {
            textDecoration: 'none',
            color: theme.palette.primary.main,
            fontWeight: '400'
        }
    },
    externalID: {
        '& label ': {
            fontWeight: 'bold',
        }
    },
    pocField: {
            fontSize: '13px',
            marginLeft: '10px'
    },
    cardColumn: {
        width: '25%'
    },
    pencilIcon: {
        color: 'black',
        fontSize: '1rem'
    },
    editDatesButton: {
        background: 'none',
        border: 'none',
        padding: '0',
        margin: '0',
        marginLeft: '0.5em',
        opacity: 0
    },
    dateWrapper: {
        display: 'flex',
        alignItems: 'center',
        "&:hover": {
            "& $editDatesButton": {
                opacity: 1,
            }
        }
    },
    dateValue: {
        marginLeft: '0.5em'
    },
    editButton: {
        marginLeft: '0.5em'
    },
    editLoadIcon: {
        // color: 'black',
        fontSize: '1.5rem'
    },
    contacts: {
        padding: '1em'
    },
    icon: {
        padding: '0.5rem',
        margin: '0 0.12rem 0 0.12rem',
        backgroundColor: '#eeeeee'
    },
    pmfIcon: {
        marginLeft: '.5rem'
    }
}));
